module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ef-snackbar",
    class: [_vm.classes],
    attrs: {
      "id": _vm.snackbarId
    },
    on: {
      "mouseenter": _vm.pauseTimeout,
      "mouseleave": _vm.resumeTimeout
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "ef-snackbar-container"
  }, [_c('div', {
    staticClass: "ef-snackbar-content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d5e3e3e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/snackbar/Snackbar.vue
// module id = 713
// module chunks = 42